import Vue from 'vue'
import Datetime from 'vue-datetime'
import { Settings } from 'luxon'
import 'vue-datetime/dist/vue-datetime.css'
import './style.scss'

Settings.defaultLocale = 'lt'
Vue.use(Datetime)
